import { BordOneToneIcon } from 'bord-design-system';
import { IQuoteBulkUpload } from 'types/quote.types';
import './QuoteDetailCommercialUploadCard.scss';

interface IQuoteDetailCommercialUploadCard {
  bulkUpload?: IQuoteBulkUpload | null;
}

/**
 * Card de la columna izquierda en el detalle de cotización exploratoria.
 * Muestra la planilla `.xlsx` cargada por comercial y permite descargarla.
 * Si no hay planilla asociada, muestra un placeholder.
 */
const QuoteDetailCommercialUploadCard = ({ bulkUpload }: IQuoteDetailCommercialUploadCard) => {
  const fileName = bulkUpload?.fileUrl?.split('/')?.pop()?.split('?')?.[0] || 'planilla.xlsx';

  const handleDownload = () => {
    if (!bulkUpload?.fileUrl) return;
    window.open(bulkUpload.fileUrl, '_blank');
  };

  return (
    <section className="quoteDetailCommercialUploadCard">
      <header className="cardHeader">
        <span className="stepNumber">1</span>
        <h3 className="cardTitle">Cotización solicitada por comercial</h3>
      </header>

      {bulkUpload && (
        <button type="button" className="fileRow" onClick={handleDownload}>
          <BordOneToneIcon variant="download" customWidth="1.6rem" />
          <span className="fileName">{fileName}</span>
        </button>
      )}

      {!bulkUpload && <div className="emptyState">Archivo no disponible</div>}
    </section>
  );
};

export default QuoteDetailCommercialUploadCard;
